import { stylesheet } from "typestyle";
import { Portal } from "../Portal";

type PageMaskProps = {
  isShow: boolean;
};

export const PageMask = ({ isShow }: PageMaskProps) => {
  if (!isShow) {
    return <></>;
  }
  return (
    <Portal>
      <div className={maskStyle.loading}>
        <div className={maskStyle.loadingIcon}></div>
      </div>
    </Portal>
  );
};

const maskStyle = stylesheet({
  loading: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 10000,
    backgroundColor: "#eee9",
    backgroundClip: "content-box",
    textAlign: "center",
  },
  loadingIcon: {
    width: "48px",
    height: "48px",
    marginTop: "40%",
    border: "5px solid #91DBF6",
    borderBottomColor: "transparent",
    position: "absolute",
    borderRadius: "50%",
    display: "inline-block",
    boxSizing: "border-box",
    animation: "rotation 1s linear infinite",
    verticalAlign: "middle",
  },
});
